module.exports = __webpack_public_path__ + "slide4-steps.17022fae6462bf9672cbddf0e6875b72.hashedasset.svg";